import React, { useEffect, useState, useRef } from "react";
import axios from "../../../utills/api";
import classnames from "classnames";
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Row,
    Spinner,
} from "reactstrap";

import { TabContent, TabPane } from "reactstrap";
import { toast } from "react-toastify";
import { FaCamera } from "react-icons/fa";
const Settings = () => {

    document.title = "Property Profile";
    const fileRef = useRef();
    const [activeTab, setActiveTab] = useState("1");

    const [profileImage, setProfileImage] =
        useState(null);

    const [profile, setProfile] = useState(null);
    const [tenantId, setTenantId] = useState("");
    const [hotelLogo, setHotelLogo] = useState("");
    const [hotelSignature, setHotelSignature] = useState("");
    const [loading, setLoading] = useState(true);
    const [client, setClient] = useState({});
    const [form, setForm] = useState({

        adminName: "",
        adminEmail: "",
        adminMobile: "",
        password: "",

        gstNumber: "",
        panNumber: "",
        businessRegistrationNumber: "",
        legalBusinessName: "",

        timeZone: "Asia/Kolkata",
        currency: "INR",
        language: "English",
        checkInTime: "14:00",
        checkOutTime: "11:00",

        bookingHotelId: "",
        expediaHotelId: "",
        agodaHotelId: "",
        airbnbPropertyId: "",

        totalRooms: 0,
        totalFloors: 0,
        propertyRating: 3,
        propertyStatus: "Active",

    });
    const tabChange = (tab) => {
        if (activeTab !== tab)
            setActiveTab(tab);
    };
    const IMAGE_BASE_URL =
        window.location.hostname === "localhost"
            ? "http://localhost:5000"
            : "";

    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));

    };

const loadProfile = async () => {
    try {

        setLoading(true);

        const res =
            await axios.get(
                "/property-profile"
            );

        console.log(
            "PROPERTY PROFILE API RESPONSE:",
            res.data
        );

        const clientData =
            res.data.client || {};

        const profileData =
            res.data.profile || {};

        // -----------------------------------------
        // CLIENT
        // -----------------------------------------

        setClient(
            clientData
        );

        // -----------------------------------------
        // TENANT
        // -----------------------------------------

        setTenantId(
            profileData.tenantId ||
            clientData.tenantId ||
            ""
        );

        // -----------------------------------------
        // BRANDING
        // -----------------------------------------

        setProfileImage(
            profileData.profileImage ||
            clientData.profileImage ||
            ""
        );

        setHotelLogo(
            profileData.hotelLogo ||
            ""
        );

        setHotelSignature(
            profileData.authorizedSignature ||
            ""
        );

        // -----------------------------------------
        // FORM
        // -----------------------------------------

        setForm({

            adminName:
                profileData.adminName ||
                clientData.adminName ||
                "",

            adminEmail:
                profileData.adminEmail ||
                clientData.adminEmail ||
                "",

            adminMobile:
                profileData.adminMobile ||
                clientData.mobile ||
                "",

            password: "",

            gstNumber:
                profileData.gstNumber ||
                "",

            panNumber:
                profileData.panNumber ||
                "",

            businessRegistrationNumber:
                profileData.businessRegistrationNumber ||
                "",

            legalBusinessName:
                profileData.legalBusinessName ||
                "",

            timeZone:
                profileData.timeZone ||
                "Asia/Kolkata",

            currency:
                profileData.currency ||
                "INR",

            language:
                profileData.language ||
                "English",

            checkInTime:
                profileData.checkInTime ||
                "14:00",

            checkOutTime:
                profileData.checkOutTime ||
                "11:00",

            bookingHotelId:
                profileData.bookingHotelId ||
                "",

            expediaHotelId:
                profileData.expediaHotelId ||
                "",

            agodaHotelId:
                profileData.agodaHotelId ||
                "",

            airbnbPropertyId:
                profileData.airbnbPropertyId ||
                "",

            totalRooms:
                profileData.totalRooms ||
                0,

            totalFloors:
                profileData.totalFloors ||
                0,

            propertyRating:
                profileData.propertyRating ||
                3,

            propertyStatus:
                profileData.propertyStatus ||
                "Active",
        });

    } catch (err) {

        console.error(
            "❌ Load property profile error:",
            err
        );

        toast.error(
            err?.response?.data?.message ||
            "Unable to load profile."
        );

    } finally {

        setLoading(false);

    }
};

    useEffect(() => {
        loadProfile();
    }, []);

    const fetchProfile = async () => {
        try {

            const res =
                await axios.get("/property-profile");

            const profileData =
                res.data.profile || res.data;

            setProfile(profileData);

            setTenantId(
                profileData?.tenantId || ""
            );

            setProfileImage(
                profileData?.profileImage || ""
            );

            setHotelLogo(
                profileData?.hotelLogo || ""
            );

        setHotelSignature(
    profileData?.authorizedSignature || ""
);

        } catch (err) {

            console.error(err);

        }
    };

    const uploadProfileImage = async (e) => {

  try {

    const file = e.target.files[0];

    if (!file) return;

    const formData = new FormData();

    formData.append(
      "profileImage",
      file
    );

    const res =
      await axios.post(
        `/property-profile/upload-profile`,
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

    setProfileImage(
      res.data.image
    );

  } catch (err) {

    console.error(err);

  }
};

const uploadHotelLogo = async (e) => {
    try {

        const file =
            e.target.files?.[0];

        if (!file) {
            return;
        }

        const formData =
            new FormData();

        formData.append(
            "hotelLogo",
            file
        );

        const res =
            await axios.post(
                "/property-profile/upload-logo",
                formData
            );

        console.log(
            "HOTEL LOGO UPLOAD RESPONSE:",
            res.data
        );

        if (
            res.data.success &&
            res.data.hotelLogo
        ) {

            setHotelLogo(
                res.data.hotelLogo
            );

            toast.success(
                "Hotel logo uploaded successfully."
            );

        }

    } catch (err) {

        console.error(
            "❌ Hotel logo upload error:",
            err
        );

        toast.error(
            err?.response?.data?.message ||
            "Unable to upload hotel logo."
        );
    }
};

const uploadSignature = async (e) => {
    try {

        const file =
            e.target.files?.[0];

        if (!file) {
            return;
        }

        const formData =
            new FormData();

        formData.append(
            "hotelSignature",
            file
        );

        const res =
            await axios.post(
                "/property-profile/upload-signature",
                formData
            );

        console.log(
            "SIGNATURE UPLOAD RESPONSE:",
            res.data
        );

        if (
            res.data.success &&
            res.data.authorizedSignature
        ) {

            setHotelSignature(
                res.data.authorizedSignature
            );

            toast.success(
                "Authorized signature uploaded successfully."
            );

        }

    } catch (err) {

        console.error(
            "❌ Signature upload error:",
            err
        );

        toast.error(
            err?.response?.data?.message ||
            "Unable to upload signature."
        );
    }
};

const getImageUrl = (imagePath) => {
    if (!imagePath) {
        return "";
    }

    if (
        imagePath.startsWith("http://") ||
        imagePath.startsWith("https://")
    ) {
        return imagePath;
    }

    return `${IMAGE_BASE_URL}${imagePath}`;
};


    const saveProfile = async () => {
        try {

            await axios.put(
                "/property-profile",
                form
            );

            toast.success(
                "Profile updated successfully."
            );

            loadProfile();

        } catch (err) {

            toast.error(
                err?.response?.data?.message ||
                "Unable to update profile."
            );

        }

    };

    if (loading) {

        return (

            <div className="page-content">

                <Container fluid>

                    <div className="text-center py-5">

                        <Spinner />

                    </div>

                </Container>

            </div>

        );

    }

    return (

        <React.Fragment>

            <div className="page-content">

                <Container fluid>

                    <Row>

                        {/* LEFT CARD */}

                        <Col md={4}>

                            <Card>

                                <CardBody>

                                    <div className="text-center">

                                        <div
                                            className="position-relative d-inline-block"
                                        >
                                            {client.profileImage ? (
                                                <img
                                                    src={`${IMAGE_BASE_URL}${client.profileImage}`}
                                                    alt="Profile"
                                                    className="rounded-circle"
                                                    style={{
                                                        width: 90,
                                                        height: 90,
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                <div
                                                    className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: 90,
                                                        height: 90,
                                                        fontSize: 30,
                                                    }}
                                                >
                                                    {client.propertyName
                                                        ?.charAt(0)
                                                        ?.toUpperCase()}
                                                </div>
                                            )}

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    fileRef.current.click()
                                                }
                                                className="btn btn-primary rounded-circle position-absolute"
                                                style={{
                                                    bottom: 0,
                                                    right: 0,
                                                    width: 30,
                                                    height: 30,
                                                    padding: 0,
                                                }}
                                            >
                                                <FaCamera size={14} />
                                            </button>

                                            <input
                                                type="file"
                                                accept="image/*"
                                                ref={fileRef}
                                                hidden
                                                onChange={uploadProfileImage}
                                            />
                                        </div>

                                        <h4 className="mt-3">

                                            {client.propertyName}

                                        </h4>

                                        <hr />

                                    </div>

                                    <div className="mb-3">

                                        <Label className="fw-bold">

                                            Property Email

                                        </Label>

                                        <div>

                                            {client.email}

                                        </div>

                                    </div>

                                    <div className="mb-3">

                                        <Label className="fw-bold">

                                            Address

                                        </Label>

                                        <div>

                                            {client.address}

                                        </div>

                                    </div>

                                    <div className="mb-3">

                                        <Label className="fw-bold">

                                            Status

                                        </Label>

                                        <div>

                                            <span className="badge bg-success">

                                                {client.status}

                                            </span>

                                        </div>

                                    </div>

                                    <div className="mb-3">

                                        <Label className="fw-bold">

                                            Subscription Plan

                                        </Label>

                                        <div>

                                            {client.subscription?.plan}

                                        </div>

                                    </div>

                                    <div>

                                        <Label className="fw-bold">

                                            Tenant ID

                                        </Label>

                                        <div>

                                            {client.tenantId}

                                        </div>

                                    </div>

                                </CardBody>

                            </Card>

                        </Col>

                        {/* RIGHT CARD */}

                        <Col md={8}>
                            <Card>
                                <CardHeader>
                                    <Nav
                                        className="nav-tabs-custom"
                                        role="tablist"
                                    >
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "1",
                                                })}
                                                onClick={() => tabChange("1")}
                                            >
                                                Contact
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "2",
                                                })}
                                                onClick={() => tabChange("2")}
                                            >
                                                Business
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "3",
                                                })}
                                                onClick={() => tabChange("3")}
                                            >
                                                Hotel Config
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "4",
                                                })}
                                                onClick={() => tabChange("4")}
                                            >
                                                OTA
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "5",
                                                })}
                                                onClick={() => tabChange("5")}
                                            >
                                                Property
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </CardHeader>
                                <CardBody>
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            <Row>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label>
                                                            Admin Name <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            name="adminName"
                                                            value={form.adminName}
                                                            onChange={handleChange}
                                                            placeholder="Enter Admin Name"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>
                                                            Admin Email <span className="text-danger">*</span>
                                                        </Label>

                                                        <Input
                                                            type="email"
                                                            name="adminEmail"
                                                            value={form.adminEmail}
                                                            onChange={handleChange}
                                                            placeholder="Enter Admin Email"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>
                                                            Admin Mobile <span className="text-danger">*</span>
                                                        </Label>

                                                        <Input
                                                            name="adminMobile"
                                                            value={form.adminMobile}
                                                            onChange={handleChange}
                                                            placeholder="Enter Mobile Number"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Password

                                                        </Label>

                                                        <Input
                                                            type="password"
                                                            name="password"
                                                            value={form.password}
                                                            onChange={handleChange}
                                                            placeholder="Leave blank to keep existing password"
                                                        />

                                                    </div>

                                                </Col>

                                            </Row>

                                        </TabPane>
                                        <TabPane tabId="2">

                                            <Row>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            GST Number

                                                        </Label>

                                                        <Input
                                                            name="gstNumber"
                                                            value={form.gstNumber}
                                                            onChange={handleChange}
                                                            placeholder="GST Number"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            PAN Number

                                                        </Label>

                                                        <Input
                                                            name="panNumber"
                                                            value={form.panNumber}
                                                            onChange={handleChange}
                                                            placeholder="PAN Number"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Business Registration Number

                                                        </Label>

                                                        <Input
                                                            name="businessRegistrationNumber"
                                                            value={form.businessRegistrationNumber}
                                                            onChange={handleChange}
                                                            placeholder="Business Registration Number"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Legal Business Name

                                                        </Label>

                                                        <Input
                                                            name="legalBusinessName"
                                                            value={form.legalBusinessName}
                                                            onChange={handleChange}
                                                            placeholder="Legal Business Name"
                                                        />

                                                    </div>

                                                </Col>

                                            </Row>

                                        </TabPane>
                                        <TabPane tabId="3">

                                            <Row>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Time Zone

                                                        </Label>

                                                        <Input
                                                            type="select"
                                                            name="timeZone"
                                                            value={form.timeZone}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="Asia/Kolkata">Asia/Kolkata</option>
                                                            <option value="Asia/Dubai">Asia/Dubai</option>
                                                            <option value="Europe/London">Europe/London</option>
                                                            <option value="America/New_York">America/New_York</option>
                                                        </Input>

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Currency <span className="text-danger">*</span>

                                                        </Label>

                                                        <Input
                                                            type="select"
                                                            name="currency"
                                                            value={form.currency}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="INR">INR</option>
                                                            <option value="USD">USD</option>
                                                            <option value="EUR">EUR</option>
                                                            <option value="AED">AED</option>
                                                        </Input>

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Language

                                                        </Label>

                                                        <Input
                                                            type="select"
                                                            name="language"
                                                            value={form.language}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="English">English</option>
                                                            <option value="Hindi">Hindi</option>
                                                        </Input>

                                                    </div>

                                                </Col>

                                                <Col md={3}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Check-In Time

                                                        </Label>

                                                        <Input
                                                            type="time"
                                                            name="checkInTime"
                                                            value={form.checkInTime}
                                                            onChange={handleChange}
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={3}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Check-Out Time

                                                        </Label>

                                                        <Input
                                                            type="time"
                                                            name="checkOutTime"
                                                            value={form.checkOutTime}
                                                            onChange={handleChange}
                                                        />

                                                    </div>

                                                </Col>

                                            </Row>

                                        </TabPane>

                                        <TabPane tabId="4">

                                            <Row>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Booking.com Hotel ID

                                                        </Label>

                                                        <Input
                                                            name="bookingHotelId"
                                                            value={form.bookingHotelId}
                                                            onChange={handleChange}
                                                            placeholder="Booking.com Hotel ID"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Expedia Hotel ID

                                                        </Label>

                                                        <Input
                                                            name="expediaHotelId"
                                                            value={form.expediaHotelId}
                                                            onChange={handleChange}
                                                            placeholder="Expedia Hotel ID"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Agoda Hotel ID

                                                        </Label>

                                                        <Input
                                                            name="agodaHotelId"
                                                            value={form.agodaHotelId}
                                                            onChange={handleChange}
                                                            placeholder="Agoda Hotel ID"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Airbnb Property ID

                                                        </Label>

                                                        <Input
                                                            name="airbnbPropertyId"
                                                            value={form.airbnbPropertyId}
                                                            onChange={handleChange}
                                                            placeholder="Airbnb Property ID"
                                                        />

                                                    </div>

                                                </Col>

                                            </Row>

                                        </TabPane>
                                        <TabPane tabId="5">

                                            <Row>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Total Rooms

                                                        </Label>

                                                        <Input
                                                            type="number"
                                                            name="totalRooms"
                                                            value={form.totalRooms}
                                                            onChange={handleChange}
                                                            min="0"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Total Floors

                                                        </Label>

                                                        <Input
                                                            type="number"
                                                            name="totalFloors"
                                                            value={form.totalFloors}
                                                            onChange={handleChange}
                                                            min="0"
                                                        />

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Property Rating

                                                        </Label>

                                                        <Input
                                                            type="select"
                                                            name="propertyRating"
                                                            value={form.propertyRating}
                                                            onChange={handleChange}
                                                        >
                                                            <option value={1}>1 Star</option>
                                                            <option value={2}>2 Star</option>
                                                            <option value={3}>3 Star</option>
                                                            <option value={4}>4 Star</option>
                                                            <option value={5}>5 Star</option>
                                                            <option value={6}>6 Star</option>
                                                            <option value={7}>7 Star</option>
                                                        </Input>

                                                    </div>

                                                </Col>

                                                <Col md={6}>

                                                    <div className="mb-3">

                                                        <Label>

                                                            Property Status

                                                        </Label>

                                                        <Input
                                                            type="select"
                                                            name="propertyStatus"
                                                            value={form.propertyStatus}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="Active">
                                                                Active
                                                            </option>

                                                            <option value="Inactive">
                                                                Inactive
                                                            </option>

                                                            <option value="Maintenance">
                                                                Maintenance
                                                            </option>

                                                            <option value="Under Renovation">
                                                                Under Renovation
                                                            </option>

                                                        </Input>

                                                    </div>

                                                </Col>

                                            </Row>

                                            <hr />

                                            <div className="d-flex justify-content-end gap-2">

                                                <button
                                                    type="button"
                                                    className="btn btn-light"
                                                    onClick={loadProfile}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={saveProfile}
                                                >
                                                    Save Changes
                                                </button>

                                            </div>

                                        </TabPane>

                                    </TabContent>

                                </CardBody>

                            </Card>

                            <Card>
                                <CardHeader>
                                    <div>
                                        <h5>Upload Property Logo and Signature</h5>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <Row className="mt-4">

                                        {/* HOTEL LOGO */}

                                        <Col md={6}>

                                            <Card>
                                                <CardBody>

                                                    <h5 className="mb-3">
                                                        Hotel Logo
                                                    </h5>

                                                    <div className="text-center">

                                                        {hotelLogo ? (

                                                            <img
                                                                src={getImageUrl(hotelLogo)}
                                                                alt="Hotel Logo"
                                                                style={{
                                                                    width: "180px",
                                                                    height: "180px",
                                                                    objectFit: "contain",
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: "8px",
                                                                    padding: "10px",
                                                                }}
                                                            />

                                                        ) : (

                                                            <div
                                                                style={{
                                                                    height: "180px",
                                                                    border:
                                                                        "2px dashed #ddd",
                                                                    borderRadius: "8px",
                                                                }}
                                                                className="d-flex align-items-center justify-content-center"
                                                            >
                                                                No Logo Uploaded
                                                            </div>

                                                        )}

                                                        <div className="mt-3">

                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                onChange={
                                                                    uploadHotelLogo
                                                                }
                                                                className="form-control"
                                                            />

                                                        </div>

                                                    </div>

                                                </CardBody>
                                            </Card>

                                        </Col>

                                        {/* VERTICAL DIVIDER */}

                                        <Col md={6}>

                                            <Card>
                                                <CardBody>

                                                    <h5 className="mb-3">
                                                        Authorized Signature
                                                    </h5>

                                                    <div className="text-center">

                                                        {hotelSignature ? (

                                                            <img
                                                                src={getImageUrl(hotelSignature)}
                                                                alt="Signature"
                                                                style={{
                                                                    width: "180px",
                                                                    height: "180px",
                                                                    objectFit: "contain",
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: "8px",
                                                                    padding: "10px",
                                                                }}
                                                            />

                                                        ) : (

                                                            <div
                                                                style={{
                                                                    height: "180px",
                                                                    border:
                                                                        "2px dashed #ddd",
                                                                    borderRadius: "8px",
                                                                }}
                                                                className="d-flex align-items-center justify-content-center"
                                                            >
                                                                No Signature Uploaded
                                                            </div>

                                                        )}

                                                        <div className="mt-3">

                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                onChange={
                                                                    uploadSignature
                                                                }
                                                                className="form-control"
                                                            />

                                                        </div>

                                                    </div>

                                                </CardBody>
                                            </Card>

                                        </Col>

                                    </Row>
                                </CardBody>
                            </Card>

                        </Col>

                    </Row>

                </Container>

            </div>

        </React.Fragment>

    );

};

export default Settings;
